import React from "react";
import Link from "next/link";
import type { LpAnnouncement } from "../Announcement";
import { AnnouncementLink } from "../Announcement";

export const AnnouncementContentLink: React.FC<{ announcement: LpAnnouncement; children: React.ReactNode }> = ({ announcement, children, }) => {
  const hasContent = announcement.content && announcement.content.trim() !== "";
  const baseUrl = process.env.BASE_URL;
  if (hasContent) {
    return (
      <Link href={`${baseUrl}/lp_news/kaleido_hp/${announcement.id}`} passHref>
        <AnnouncementLink target="_blank" rel="noopener noreferrer">
          {children}
        </AnnouncementLink>
      </Link>
    );
  }
  return <>{children}</>;
};
